

'use strict';

export const ActionConstants = Object.freeze({
  requestService: 'requestService'
});
